<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/duVZvR/tc-custom/9780253005632.jpg?1721442224710" alt="This image is the cover for the book Tel-Aviv, the First Century, Israel Studies"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tel-Aviv, the First Century, Israel Studies
      </h1>
      <p class="bookDescription body article font2">
        <b>“A learned and engaging collection of essays” on Israel’s diverse, modern metropolis, established in 1909 (<i>Religious Studies Review</i>).</b><br/>  <br/><i>Tel-Aviv, the First Century</i> brings together a broad range of scholars and cutting-edge research to trace the development and paradoxes of Tel-Aviv as an urban center and a national symbol. Through the lenses of history, literature, urban planning, gender studies, architecture, art, and other fields, these essays reveal the place of Tel-Aviv in the life and imagination of its diverse inhabitants. The careful and insightful tracing of the development of the city's landscape, the relationship of its varied architecture to its competing social cultures, and its evolving place in Israel's literary imagination come together to offer a vivid and complex picture of Tel-Aviv as a microcosm of Israeli life and a vibrant, modern, global city.<br/>  <br/> “Israel’s main metropolis is scrutinized through the lens of history, geography, architecture, art, literature, and gender studies, presenting the many facets that have come to constitute the elaborate personality of a very complicated city and society.”—<i>H-Judaic</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maoz Azaryahu, S. Ilan Troen
      </h2>
      
      <p class="authorDescription body article">Maoz Azaryahu is Professor of Cultural Geography at the University of Haifa and author of Tel Aviv: Mythography of a City.S. Ilan Troen is Stoll Family Professor of Israel Studies and Director of the Schusterman Center for Israel Studies at Brandeis University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1625e3c5